import React from "react";

interface NotFoundPageProps {
  message?: string;
}

export function NotFoundPage({ message }: NotFoundPageProps = {}) {
  return (
    <>
      <h1>Not found</h1>
      {message && <p>{message}</p>}
    </>
  );
}
